import { useEffect } from "react";
import { useLocation } from "react-router";
import { useAtomValue, useSetAtom } from "jotai";
import { type AppRouteKey, getRouteObject } from "src/utils/appRoutes/appRoutes";
import { aiAssistantRoutePromptsSuggestionsAtom } from "./AiAssistantPromptsSuggestions.hooks.atoms";

export const useGetCurrentPageRoute = () => {
  const { pathname } = useLocation();
  return getRouteObject(pathname);
};

/**
 * Set dynamic prompt suggestions for a page. Keys the atom by `routeKey` so it
 * aligns with the static JSON keys (also `route.key`) used by
 * `getStaticPromptsForRoute`.
 */
export const useSetAiAssistantRoutePromptsSuggestions = (
  routeKey: AppRouteKey,
  prompts: string[]
) => {
  const setAiAssistantRoutePromptsSuggestions = useSetAtom(
    aiAssistantRoutePromptsSuggestionsAtom
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: stable
  useEffect(() => {
    setAiAssistantRoutePromptsSuggestions((prev) => ({
      ...prev,
      [routeKey]: prompts,
    }));
  }, [routeKey, prompts]);
};

/** Get the suggested prompts for the current page route */
export const useGetAiAssistantRoutePromptsSuggestions = () => {
  const pageRoute = useGetCurrentPageRoute();
  const aiAssistantRoutePromptsSuggestions = useAtomValue(
    aiAssistantRoutePromptsSuggestionsAtom
  );

  if (!pageRoute) return [];

  return aiAssistantRoutePromptsSuggestions[pageRoute.key] ?? [];
};
